import { Icon, RouterState } from '@monash/portal-react';
import { useContext } from 'react';
import c from './applications.module.scss';
import TileButton from '../../common/tile-button/TileButton';
import ACCESS_ROLES from '../../../constants/user-roles';
import { AuthContext } from '@monash/portal-frontend-common';

const Applications = () => {
  const { redirect } = useContext(RouterState);
  const authCtx = useContext(AuthContext);
  const userRoles = authCtx?.user?.roles;
  const {
    ADMIN,
    UPDATES_ADMIN,
    UPDATES_DRAFT,
    SUPPORT_DEVELOPER,
    LINKS_ADMIN,
    LINKS_DRAFT,
  } = ACCESS_ROLES;

  const allApps = [
    {
      name: 'Home',
      link: '/home/updates',
      desc: 'Portal home updates',
      icon: <Icon.Home />,
      requiredRoles: [ADMIN, UPDATES_ADMIN, UPDATES_DRAFT],
    },
    {
      name: 'Links',
      link: '/links/links',
      desc: 'Links CRUD',
      icon: <Icon.Link />,
      requiredRoles: [ADMIN, SUPPORT_DEVELOPER, LINKS_ADMIN, LINKS_DRAFT],
    },
  ];

  return (
    <div className={c.container}>
      <div className={c.applications}>
        <h1 tabIndex={-1}>Available Applications</h1>
        <p>Monash applications content management</p>
        <div className={c.appList}>
          {allApps
            .filter(
              (app) =>
                !app.requiredRoles ||
                app.requiredRoles.some((role) => userRoles?.includes(role))
            )
            .map((app) => (
              <TileButton
                key={app.name}
                onClick={() => redirect(`apps${app.link}`)}
                icon={app.icon}
                title={app.name}
                description={app.desc}
              />
            ))}
        </div>
      </div>
    </div>
  );
};

export default Applications;
